import { render } from "./AssetCircles.vue?vue&type=template&id=5388d5d4&scoped=true"
import script from "./AssetCircles.vue?vue&type=script&lang=js"
export * from "./AssetCircles.vue?vue&type=script&lang=js"

import "./AssetCircles.vue?vue&type=style&index=0&id=5388d5d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5388d5d4"]])

export default __exports__